// src/components/appComponents/UnauthLayout.js
// Shell for the signed-out site: header, the routed page, footer and cookie notice.
// Sign in / sign up are a focused card, so they skip the footer and the cookie notice.
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import SiteNav from '../../unAuthPages/site/SiteNav';
import SiteFooter from '../../unAuthPages/site/SiteFooter';
import CookieBar from '../miscComponents/CookieBar';
import '../../unAuthPages/site/site.css';

const UnauthLayout = () => {
  const isAuthPage = /^\/sign(in|up)/.test(useLocation().pathname);
  return (
    <div className="mk-site">
      {/* Pages set their own titles; this fallback keeps a previous page's title from lingering */}
      <Helmet><title>Bumpups</title></Helmet>
      <SiteNav />
      <main className="mk-main">
        <Outlet />
      </main>
      {!isAuthPage && <SiteFooter />}
      {!isAuthPage && <CookieBar />}
    </div>
  );
};

export default UnauthLayout;
